// Przycisk dodawania/usuwania produktu z ulubionych

import React, { FC, useState, useEffect } from 'react';
import { Heart, HeartFill } from 'react-bootstrap-icons';
import { usePostShoppingListTypeAddProduct, useDeleteShoppingListTypeProduct } from 'api';
import styles from 'theme/components/containers/FavoriteButton/FavoriteButton.module.scss';

interface Props {
  productId: number;
  unitId: number;
  inFavourite: boolean;
}

const FAVORITES_TYPE = 'FAVORITES';

const FavoriteButton: FC<Props> = ({ productId, unitId, inFavourite }) => {
  const [isFavourite, setIsFavourite] = useState(inFavourite);

  useEffect(() => {
    setIsFavourite(inFavourite);
  }, [inFavourite]);

  const { mutate: addToFavourites } = usePostShoppingListTypeAddProduct({
    onMutate: () => setIsFavourite(true),
    onError: () => setIsFavourite(false)
  });

  const { mutate: removeFromFavourites } = useDeleteShoppingListTypeProduct(
    FAVORITES_TYPE,
    productId,
    unitId,
    {
      onMutate: () => setIsFavourite(false),
      onError: () => setIsFavourite(true)
    }
  );

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    if (isFavourite) {
      removeFromFavourites();
    } else {
      addToFavourites({ productId, unitId, quantity: 1, type: FAVORITES_TYPE });
    }
  };

  return (
    <button
      className={styles.favoriteButton}
      onClick={handleClick}
      aria-label={isFavourite ? 'Usuń z ulubionych' : 'Dodaj do ulubionych'}
      type="button">
      {isFavourite ? (
        <HeartFill className={styles.filled} />
      ) : (
        <Heart className={styles.empty} />
      )}
    </button>
  );
};

export default FavoriteButton;
